<h1 class='videos__headline'>{{ 'videos.videoTutorials' | translate }}</h1>
@if (loading) {
  <div class='videos__spinner-wrapper'>
    <mat-progress-spinner class='videos__spinner' mode='indeterminate'></mat-progress-spinner>
  </div>
}
@if (userService.includesRoles(["Admin", "Office", "Sale"])) {
  <div class='videos__video' [ngClass]="{'hidden': loading}">
    <h3 class='videos__title'>{{ 'videos.consultantOverview' | translate }}</h3>
    <iframe class='videos__frame'
            src="https://player.vimeo.com/video/1147594404?badge=0&amp;autopause=0&amp;player_id=0&amp;a… "
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin" title="Profiler - Beraterübersicht">
    </iframe>
  </div>
  <div class='videos__video' [ngClass]="{'hidden': loading}">
    <h3 class='videos__title'>{{ 'videos.reports' | translate }}</h3>
    <iframe class='videos__frame'
            src="https://player.vimeo.com/video/1147599216?badge=0&amp;autopause=0&amp;player_id=0&amp;a…"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin" title="Profiler - Zeugnistexte">
    </iframe>
  </div>
}
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.register' | translate }}</h3>
  <iframe (load)='loading=false' class='videos__frame'
          src="https://player.vimeo.com/video/1147351662?title=0&amp;byline=0&amp;portrait=0&amp;badge… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          title="Profiler - Registrierung">
  </iframe>
</div>
@if (userService.includesRoles(["Admin", "Office", "Sale", "User"])) {
<h2 class='videos__headline' [ngClass]="{'hidden': loading}">{{ 'videos.consultantProfile' | translate }}</h2>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.profile' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147605757?badge=0&amp;autopause=0&amp;player_id=0&amp;a… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin" title="Profiler - Profil">
  </iframe>
</div>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.personalData' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147607771?title=0&amp;byline=0&amp;portrait=0&amp;badge… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          title="Profiler - Benutzerprofil – Persönliche Daten">
  </iframe>
</div>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.education' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147611372?badge=0&amp;autopause=0&amp;player_id=0&amp;a… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          title="Profiler - Benutzerprofil – Section Ausbildung">
  </iframe>
</div>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.career' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147635703?badge=0&amp;autopause=0&amp;player_id=0&amp;a… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          title="Profiler - Benutzerprofil – Section Werdegang">
  </iframe>
</div>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.trainings' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147635983?badge=0&amp;autopause=0&amp;player_id=0&amp;a… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin" title="Profiler - Benutzerprofil – Section Schulungen">
  </iframe>
</div>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.certificates' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147619472?title=0&amp;byline=0&amp;portrait=0&amp;badge… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          title="Profiler - Benutzerprofil – Section Zertifikate">
  </iframe>
</div>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.projects' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147625073?badge=0&amp;autopause=0&amp;player_id=0&amp;a… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin" title="Profiler - Benutzerprofil – Section Projekte">
  </iframe>
</div>
<div class='videos__video' [ngClass]="{'hidden': loading}">
  <h3 class='videos__title'>{{ 'videos.skills' | translate }}</h3>
  <iframe class='videos__frame'
          src="https://player.vimeo.com/video/1147628156?badge=0&amp;autopause=0&amp;player_id=0&amp;a… "
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          title="Profiler - Benutzerprofil – Section Fähigkeiten">
  </iframe>
</div>
}
<script src="https://player.vimeo.com/api/player.js">
</script>
